import type { SiteOption, StrapiResponse } from '~/types/strapi';

export const useSiteOptions = (locale: string) => {
  const key = `global-site-options-${locale}`;

  // Manual cache key check
  const { data: cached } = useNuxtData<StrapiResponse<SiteOption>>(key);
  if (cached.value) {
    return { data: cached };
  }

  return useAsyncData<StrapiResponse<SiteOption>>(
    key,
    async () => {
      const response = await $fetch<StrapiResponse<SiteOption>>('/api/site-options', {
        query: {
          locale,
        },
      });
      return response;
    },
    {
      dedupe: 'defer',
    }
  );
};
